/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var Account;
(function (Account) {
    let scope;
    (function (scope) {
        scope["ACCOUNT"] = "account";
    })(scope = Account.scope || (Account.scope = {}));
})(Account || (Account = {}));
//# sourceMappingURL=Account.js.map